import React, { memo, useMemo } from 'react';
import { HStack, Text, Box } from 'native-base';
import { Iconography, Typography } from 'fmc-digital-common';
const TrackingStatusSnackbar = /*#__PURE__*/memo(({
  taskUploadErrorMessage,
  infoData,
  errorData
}) => {
  const getColor = useMemo(() => {
    if (infoData) {
      return 'info.900';
    } else if (errorData) {
      return 'error.800';
    } else {
      return 'error.900';
    }
  }, [infoData, errorData]);
  const backgroundColor = useMemo(() => {
    if (infoData) {
      return 'gray.300';
    } else if (errorData) {
      return 'error.700';
    } else {
      return 'error.700';
    }
  }, [infoData, errorData]);
  return /*#__PURE__*/React.createElement(Box, {
    py: "2",
    px: "4",
    minH: "12",
    borderRadius: 8,
    backgroundColor: backgroundColor,
    alignItems: 'flex-start',
    marginTop: 2,
    testID: "tracking-error-snackbar"
  }, /*#__PURE__*/React.createElement(HStack, {
    flex: 1,
    space: 3,
    flexDirection: 'row',
    w: "100%",
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(Iconography, {
    name: 'error',
    color: getColor,
    size: 20
  }), /*#__PURE__*/React.createElement(HStack, {
    flex: 2,
    space: 2,
    alignItems: "center",
    marginRight: 8
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "regular",
    color: getColor,
    numberOfLines: 5
  }, /*#__PURE__*/React.createElement(Text, {
    fontWeight: 'normal'
  }, taskUploadErrorMessage))))));
});
export default TrackingStatusSnackbar;
//# sourceMappingURL=index.js.map